import React, { FC } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { OrderPartsContainer, OrderTop } from '@container/index';

import { PARTS_PATH } from '@app/react/const/variables';

export const AppRoute: FC = () => (
    <Router basename="/order_made">
        <Switch>
            <Route exact path="/" component={OrderTop} />
            <Switch>
                <Route path={PARTS_PATH} component={OrderPartsContainer} />
            </Switch>
        </Switch>
    </Router>
);
